<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom: 35px;">About the Author</h1>
<p>Robin Jenner has had a varied career, being a musician, songwriter, accountant and community worker, and now works as a volunteer at Gloucester Cathedral. He also buys and sells Wedgwood pottery. He has previously brought out a book featuring famous people from the 18<sup>th</sup> century as although interested in history generally, it is the 18<sup>th</sup> century that is his main level of expertise.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1ffbebf8